(function () {
  var desktopMediaQuery = window.matchMedia("(min-width: 992px)");

  function getBootstrapCollapse(element) {
    if (!element || !window.bootstrap || !window.bootstrap.Collapse) {
      return null;
    }

    return window.bootstrap.Collapse.getOrCreateInstance(element, { toggle: false });
  }

  function getSelectorTarget(trigger, attributeName) {
    var selector = trigger.getAttribute(attributeName);

    if (!selector || selector.charAt(0) !== "#") {
      return null;
    }

    return document.querySelector(selector);
  }

  function getServiceTileCollapse(serviceTile, toggleButton) {
    return (
      getSelectorTarget(toggleButton, "data-bs-target") ||
      getSelectorTarget(toggleButton, "href") ||
      serviceTile.querySelector(".service-tile__collapse")
    );
  }

  function setServiceTileOpenState(serviceTile, isOpen) {
    if (!serviceTile) {
      return;
    }

    serviceTile.classList.toggle("is-open", isOpen);
  }

  function closeSiblingServiceTiles(currentCollapse) {
    var sectionGrid = currentCollapse.closest(".services-section__grid");

    if (!sectionGrid) {
      return;
    }

    sectionGrid.querySelectorAll(".service-tile__collapse.show").forEach(function (collapseElement) {
      if (collapseElement === currentCollapse) {
        return;
      }

      var collapseInstance = getBootstrapCollapse(collapseElement);

      if (collapseInstance) {
        collapseInstance.hide();
      }
    });
  }

  function syncServiceAccordionState() {
    if (!desktopMediaQuery.matches) {
      return;
    }

    document.querySelectorAll(".services-section__grid").forEach(function (gridElement) {
      var openCollapses = Array.from(gridElement.querySelectorAll(".service-tile__collapse.show"));

      openCollapses.slice(1).forEach(function (collapseElement) {
        var collapseInstance = getBootstrapCollapse(collapseElement);

        if (collapseInstance) {
          collapseInstance.hide();
        }
      });
    });
  }

  function initServiceTile(serviceTile) {
    var toggleButton = serviceTile.querySelector(".service-tile__toggle");
    var collapseElement = toggleButton ? getServiceTileCollapse(serviceTile, toggleButton) : null;

    if (!toggleButton || !collapseElement) {
      return;
    }

    collapseElement.addEventListener("show.bs.collapse", function () {
      setServiceTileOpenState(serviceTile, true);

      if (desktopMediaQuery.matches) {
        closeSiblingServiceTiles(collapseElement);
      }
    });

    collapseElement.addEventListener("hide.bs.collapse", function () {
      setServiceTileOpenState(serviceTile, false);
    });

    serviceTile.addEventListener("click", function (event) {
      if (event.target.closest("a, button")) {
        return;
      }

      if (serviceTile.classList.contains("is-open") && event.target.closest(".service-tile__collapse")) {
        return;
      }

      toggleButton.click();
    });

    setServiceTileOpenState(serviceTile, collapseElement.classList.contains("show"));
  }

  function initServiceTiles() {
    document.querySelectorAll(".service-tile").forEach(initServiceTile);
    syncServiceAccordionState();
  }

  function validateCurrentStep(stepElement) {
    if (!stepElement) {
      return true;
    }

    var requiredInputs = Array.from(stepElement.querySelectorAll("[required]"));
    var radioNames = [];

    for (var i = 0; i < requiredInputs.length; i += 1) {
      var input = requiredInputs[i];

      if (input.type === "radio") {
        if (radioNames.indexOf(input.name) === -1) {
          radioNames.push(input.name);
        }

        continue;
      }

      if (!input.checkValidity()) {
        input.reportValidity();
        return false;
      }
    }

    for (var j = 0; j < radioNames.length; j += 1) {
      var radioName = radioNames[j];
      var checkedRadio = stepElement.querySelector('input[type="radio"][name="' + radioName + '"]:checked');
      var firstRadio = stepElement.querySelector('input[type="radio"][name="' + radioName + '"]');

      if (!checkedRadio && firstRadio) {
        firstRadio.reportValidity();
        return false;
      }
    }

    return true;
  }

  function setActiveContactStep(formElement, nextStep) {
    var stepPanels = formElement.querySelectorAll("[data-step]");
    var formPanel = formElement.closest(".contact-form-panel") || formElement.parentElement;
    var indicators = formPanel ? formPanel.querySelectorAll("[data-step-indicator]") : [];

    stepPanels.forEach(function (panel) {
      var isMatch = panel.getAttribute("data-step") === nextStep;
      panel.hidden = !isMatch;
      panel.classList.toggle("is-active", isMatch);
    });

    Array.prototype.forEach.call(indicators, function (indicator) {
      var indicatorStep = Number(indicator.getAttribute("data-step-indicator"));
      var numericStep = nextStep === "success" ? 3 : Number(nextStep);
      var isActive = indicatorStep === numericStep && nextStep !== "success";
      var isComplete = indicatorStep < numericStep || nextStep === "success";

      indicator.classList.toggle("is-active", isActive);
      indicator.classList.toggle("is-complete", isComplete);
    });
  }

  function setContactFeedback(formElement, message) {
    var feedbackElement = formElement.querySelector("[data-contact-feedback]");

    if (!feedbackElement) {
      return;
    }

    feedbackElement.textContent = message || "";
    feedbackElement.classList.toggle("d-none", !message);
  }

  function setContactSubmitState(formElement, isLoading) {
    var submitButton = formElement.querySelector('button[type="submit"]');

    if (!submitButton) {
      return;
    }

    submitButton.disabled = isLoading;
    submitButton.setAttribute("aria-busy", isLoading ? "true" : "false");
  }

  function getCheckedValues(formElement, fieldName) {
    return Array.from(formElement.querySelectorAll('input[name="' + fieldName + '"]:checked'))
      .map(function (input) {
        return input.value;
      });
  }

  function buildContactMessage(formElement) {
    var contactMessageField = formElement.querySelector('[name="contact_message"]');
    return contactMessageField ? contactMessageField.value.trim() : "";
  }

  function buildContactPayload(formElement, completionTime) {
    var projectGoalInput = formElement.querySelector('input[name="project_goal"]:checked');
    var projectVolumeInput = formElement.querySelector('input[name="project_volume"]:checked');
    var projectStartInput = formElement.querySelector('input[name="project_start"]:checked');
    var dataTypes = getCheckedValues(formElement, "data_types[]");
    var nameField = formElement.querySelector('[name="contact_name"]');
    var companyField = formElement.querySelector('[name="contact_company"]');
    var emailField = formElement.querySelector('[name="contact_email"]');
    var phoneField = formElement.querySelector('[name="contact_phone"]');
    var privacyField = formElement.querySelector('[name="contact_privacy"]');
    var honeypotField = formElement.querySelector('[name="website"]');
    var payload = {
      website: honeypotField ? honeypotField.value.trim() : "",
      was: projectGoalInput ? projectGoalInput.value : "",
      daten: dataTypes,
      umfang: projectVolumeInput ? projectVolumeInput.value : "",
      wann: projectStartInput ? projectStartInput.value : "",
      name: nameField ? nameField.value.trim() : "",
      firma: companyField ? companyField.value.trim() : "",
      email: emailField ? emailField.value.trim() : "",
      telefon: phoneField ? phoneField.value.trim() : "",
      message: buildContactMessage(formElement),
      privacy: privacyField ? privacyField.checked : false,
      completion_time: completionTime
    };

    return payload;
  }

  function initContactForm(formElement) {
    var startedAt = Date.now();
    var submitEndpoint = formElement.getAttribute("data-submit-endpoint") || "/wp-json/ec/v1/opnform/submit";

    formElement.querySelectorAll("[data-step-next]").forEach(function (button) {
      button.addEventListener("click", function () {
        var currentStep = button.closest("[data-step]");
        var nextStep = String(Number(currentStep.getAttribute("data-step")) + 1);

        if (!validateCurrentStep(currentStep)) {
          return;
        }

        setActiveContactStep(formElement, nextStep);
      });
    });

    formElement.querySelectorAll("[data-step-prev]").forEach(function (button) {
      button.addEventListener("click", function () {
        var currentStep = button.closest("[data-step]");
        var previousStep = String(Number(currentStep.getAttribute("data-step")) - 1);

        setActiveContactStep(formElement, previousStep);
      });
    });

    formElement.addEventListener("submit", function (event) {
      var currentStep = formElement.querySelector('[data-step="3"]');
      var payload;
      var controller;
      var timeoutId;
      var completionTime;

      event.preventDefault();
      setContactFeedback(formElement, "");

      if (!validateCurrentStep(currentStep)) {
        setContactFeedback(formElement, "Bitte prüfen Sie die markierten Felder.");
        return;
      }

      completionTime = Math.max(1, Math.round((Date.now() - startedAt) / 1000));
      payload = buildContactPayload(formElement, completionTime);

      if (!payload.name || !payload.email || !payload.message || !payload.privacy) {
        setContactFeedback(formElement, "Bitte prüfen Sie die markierten Felder.");
        return;
      }

      controller = typeof window.AbortController === "function" ? new window.AbortController() : null;
      timeoutId = window.setTimeout(function () {
        if (controller) {
          controller.abort();
        }
      }, 15000);

      setContactSubmitState(formElement, true);

      window.fetch(submitEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify(payload),
        signal: controller ? controller.signal : undefined
      }).then(function (response) {
        if (!response.ok) {
          throw new Error("Proxy-Request fehlgeschlagen: " + response.status);
        }

        return response.json();
      }).then(function (responseData) {
        if (!responseData || responseData.ok !== true) {
          throw new Error("Ungültige Proxy-Antwort.");
        }

        setActiveContactStep(formElement, "success");
        formElement.reset();
        startedAt = Date.now();
      }).catch(function () {
        setContactFeedback(formElement, "Fehler beim Senden. Bitte versuchen Sie es erneut oder kontaktieren Sie uns direkt.");
      }).finally(function () {
        window.clearTimeout(timeoutId);
        setContactSubmitState(formElement, false);
      });
    });
  }

  function initContactForms() {
    document.querySelectorAll("[data-contact-form]").forEach(initContactForm);
  }

  function getHeaderMobilePanel(headerElement) {
    var toggler = headerElement.querySelector(".site-header__toggler");

    if (!toggler) {
      return headerElement.querySelector(".site-header__mobile-panel");
    }

    return (
      getSelectorTarget(toggler, "data-bs-target") ||
      document.getElementById(toggler.getAttribute("aria-controls")) ||
      headerElement.querySelector(".site-header__mobile-panel")
    );
  }

  function initMobileHeaderLinks(headerElement) {
    var mobileNavElement = getHeaderMobilePanel(headerElement);

    if (!mobileNavElement || !window.bootstrap || !window.bootstrap.Collapse) {
      return;
    }

    var collapseInstance = window.bootstrap.Collapse.getOrCreateInstance(mobileNavElement, { toggle: false });

    mobileNavElement.querySelectorAll('a[href^="#"]').forEach(function (link) {
      link.addEventListener("click", function () {
        window.setTimeout(function () {
          collapseInstance.hide();
        }, 0);
      });
    });
  }

  function initHeaderFooterVisibility(headerElement) {
    var footerElement = document.querySelector(".site-footer");
    var mobileMediaQuery = window.matchMedia("(max-width: 991.98px)");

    if (!footerElement || typeof window.IntersectionObserver !== "function") {
      return;
    }

    var observer = new window.IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!mobileMediaQuery.matches) {
          headerElement.classList.remove("is-hidden-on-mobile");
          return;
        }

        headerElement.classList.toggle("is-hidden-on-mobile", entry.isIntersecting);
      });
    }, {
      threshold: 0.05
    });

    observer.observe(footerElement);

    var syncHeaderVisibility = function () {
      if (!mobileMediaQuery.matches) {
        headerElement.classList.remove("is-hidden-on-mobile");
      }
    };

    if (typeof mobileMediaQuery.addEventListener === "function") {
      mobileMediaQuery.addEventListener("change", syncHeaderVisibility);
    } else if (typeof mobileMediaQuery.addListener === "function") {
      mobileMediaQuery.addListener(syncHeaderVisibility);
    }
  }

  function initHeaderScrollState(headerElement) {
    var backToTopElement = document.querySelector(".site-footer__backtotop");
    var footerElement = document.querySelector(".site-footer");

    if (!headerElement && !backToTopElement) {
      return;
    }

    var updateScrollState = function () {
      var isDesktop = window.matchMedia("(min-width: 992px)").matches;
      var backToTopThreshold = window.innerHeight * (isDesktop ? 0.85 : 1.05);
      var shouldDockBackToTop = false;
      var isHeaderCondensed = window.scrollY > 8;
      var isBackToTopVisible = window.scrollY > backToTopThreshold;

      if (headerElement) {
        headerElement.classList.toggle("is-condensed", isHeaderCondensed);
        headerElement.classList.toggle("is-backtotop-active", !isDesktop && isBackToTopVisible);
      }

      if (backToTopElement) {
        backToTopElement.classList.toggle("is-visible", isBackToTopVisible);

        if (isDesktop && footerElement) {
          var footerTop = footerElement.getBoundingClientRect().top;
          var backToTopHeight = backToTopElement.offsetHeight || 0;
          shouldDockBackToTop = footerTop <= window.innerHeight - backToTopHeight - 24;
        }

        backToTopElement.classList.toggle("is-docked", shouldDockBackToTop);
      }
    };

    updateScrollState();
    window.addEventListener("scroll", updateScrollState, { passive: true });
    window.addEventListener("resize", updateScrollState);
  }

  function initSiteHeader(headerElement) {
    initMobileHeaderLinks(headerElement);
    initHeaderFooterVisibility(headerElement);
    initHeaderScrollState(headerElement);
  }

  document.addEventListener("DOMContentLoaded", function () {
    initServiceTiles();
    initContactForms();
    document.querySelectorAll(".site-header").forEach(initSiteHeader);
  });

  if (typeof desktopMediaQuery.addEventListener === "function") {
    desktopMediaQuery.addEventListener("change", syncServiceAccordionState);
  } else if (typeof desktopMediaQuery.addListener === "function") {
    desktopMediaQuery.addListener(syncServiceAccordionState);
  }
})();

  // Navbar show/hide behavior
  var wrapperNavbar = document.getElementById('wrapper-navbar');
  if (wrapperNavbar) {
    var navbarToggler = wrapperNavbar.querySelector('.hamburger');
    var lastY = window.scrollY || 0;
    var threshold = 8;

    function applyBodyOffset() { document.body.style.paddingTop = wrapperNavbar.offsetHeight + 'px'; }
    function atTop() { return (window.scrollY || 0) <= 0; }
    function isCollapseOpen() { return !!wrapperNavbar.querySelector('.navbar-collapse.show'); }
    function syncHamburgerState(isOpen) {
      if (!navbarToggler) {
        return;
      }

      navbarToggler.classList.toggle('is-active', isOpen);
      navbarToggler.classList.toggle('collapsed', !isOpen);
      navbarToggler.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }

    function updateNavbarOnScroll() {
      var y = window.scrollY || 0;
      if (atTop()) {
        wrapperNavbar.classList.add('navbar-transparent');
        wrapperNavbar.classList.remove('bg-white');
        wrapperNavbar.classList.remove('navbar-hidden');
      } else {
        wrapperNavbar.classList.remove('navbar-transparent');
        if (!isCollapseOpen()) {
          if (y > lastY + threshold) { wrapperNavbar.classList.add('navbar-hidden'); wrapperNavbar.classList.remove('bg-white'); }
          else if (y < lastY - threshold) { wrapperNavbar.classList.remove('navbar-hidden'); wrapperNavbar.classList.add('bg-white'); }
        } else { wrapperNavbar.classList.remove('navbar-hidden'); wrapperNavbar.classList.add('bg-white'); }
      }
      lastY = y;
    }

    applyBodyOffset();
    updateNavbarOnScroll();
    syncHamburgerState(isCollapseOpen());
    window.addEventListener('resize', applyBodyOffset);
    window.addEventListener('scroll', updateNavbarOnScroll, { passive: true });

    document.addEventListener('show.bs.collapse', function (e) {
      if (wrapperNavbar.contains(e.target)) {
        wrapperNavbar.classList.remove('navbar-hidden');
        wrapperNavbar.classList.add('bg-white');
        syncHamburgerState(true);
      }
    });
    document.addEventListener('hide.bs.collapse', function (e) {
      if (wrapperNavbar.contains(e.target)) {
        syncHamburgerState(false);
        setTimeout(updateNavbarOnScroll, 200);
      }
    });
  }
